/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProcessingLineSetupTimeDto } from '../models/ProcessingLineSetupTimeDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProcessingLineSetupTimeControllerService {
    /**
     * @param uuid
     * @returns ProcessingLineSetupTimeDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<ProcessingLineSetupTimeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/processing-line-setup-times/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns ProcessingLineSetupTimeDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: ProcessingLineSetupTimeDto,
    ): CancelablePromise<ProcessingLineSetupTimeDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/processing-line-setup-times/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/processing-line-setup-times/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns ProcessingLineSetupTimeDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<ProcessingLineSetupTimeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/processing-line-setup-times',
        });
    }
    /**
     * @param requestBody
     * @returns ProcessingLineSetupTimeDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: ProcessingLineSetupTimeDto,
    ): CancelablePromise<ProcessingLineSetupTimeDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/processing-line-setup-times',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param resourceTypeId
     * @returns ProcessingLineSetupTimeDto OK
     * @throws ApiError
     */
    public static getByResourceType(
        resourceTypeId: number,
    ): CancelablePromise<Array<ProcessingLineSetupTimeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/processing-line-setup-times/resource-type/{resourceTypeId}',
            path: {
                'resourceTypeId': resourceTypeId,
            },
        });
    }
}
